import { PropsWithChildren, useState } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { getSessionData, SessionData } from "@/handlers/session";

export interface AuthProviderProps extends PropsWithChildren {
  initialData: SessionData;
}

export const AuthProvider = ({ children, initialData }: AuthProviderProps) => {
  const [sessionData, setSessionData] = useState<SessionData>(initialData);

  async function refetch() {
    const data = await getSessionData();
    setSessionData(data);
  }

  return (
    <AuthContext.Provider value={{ data: sessionData, refetch }}>
      {children}
    </AuthContext.Provider>
  );
};
